import Utils from "../../../utils/utils";
import Vue from 'vue'

export const  getWantBuyDetails = ({ commit, state }, params) => {
    return new Promise((reslove, reject) => { 
        Utils.GET(Utils.accountUrl + `/wantBuy/wantBuyDetails?wantBuyId=${params.id}`, res => {
            commit("SET_WANG_BUY_DETAILS", res.data)
            commit("COUNT_TOTAL_OFFER",res.data.wantBuyAndDetails.details)
            reslove(res)
        })
    })
}
export const wantOfferAddOffer = ({ commit, state }, params) => {
    return new Promise((reslove, reject) => { 
        Utils.post(Utils.companyUrl + `/wantOffer/addOffer`,params, res => {
           
            reslove(res)
        })
    })
}

export const wantOfferSubmit = ({ commit, state }, params) => {
    return new Promise((reslove, reject) => { 
        Utils.post(Utils.companyUrl + `/wantOffer/submit`, params, (res,error) => {
            console.log("wantOfferSubmit",res,error)
            reslove(res)
        })
    })
}
export const getWantOfferList = ({ commit, state }, params) => {
    return new Promise((reslove, reject) => { 
        Utils.GET(Utils.companyUrl + `/wantOffer/offerList?page=${params.page}&rows=${params.rows}&status=${params.status}`, res => {
            commit("SET_WANG_OFFER_LIST", res.data)
            reslove(res)
        })
    })
}
//撤销报价
export const wantOfferCancelOffer = ({ commit, state }, params) => {
    return new Promise((reslove, reject) => { 
        Utils.post(Utils.companyUrl + `/wantOffer/cancelOffer`,params, res => {
            reslove(res)
        })
    })
}
//删除报价
export const wantOfferDeleteByIds = ({ commit, state }, params) => {
    return new Promise((reslove, reject) => { 
        Utils.post(Utils.companyUrl + `/wantOffer/deleteByIds`,params, res => {
            reslove(res)
        })
    })
}
// 查询用户这次报价还有几次修改的机会
export const getWantOfferLeftOfferTimes = ({ commit, state }, params) => {
    return new Promise((reslove, reject) => { 
        Utils.GET(Utils.companyUrl + `/wantOffer/leftOfferTimes?wantBuyId=${params.id}`, res => {
            reslove(res)
        })
    })
}

//清空历史报价
export const wantOfferClean = ({ commit, state }, params) => {
    return new Promise((reslove, reject) => { 
        Utils.post(Utils.companyUrl + `/wantOffer/clean`,params, res => {
            reslove(res)
        })
    })
}


// WEBPACK FOOTER //
// ./src/view/procurement/store/action.js